import "./assets/styles/App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import urls from "./config/urls.json";
import logo from "./assets/imgs/logo.svg";
import logoC5 from "./assets/imgs/logoC5.png";
import { PrestitoBusinessPage } from "./pages/p5/PrestitoBusinessPage/PrestitoBusinessPage";
import { LuogoPage } from "./pages/LuogoPage/LuogoPage";
import { LuogoC5Page } from "./pages/p3/LuogoC5Page/LuogoC5Page";
import { FilialiPage } from "./pages/FilialiPage/FilialiPage";
import { FilialiDirectC5Page } from "./pages/p3/FilialiDirectC5Page/FilialiDirectC5Page";
import { FilialiDirectPage } from "./pages/FilialiDirectPage/FilialiDirectPage";
import { ClinkDirectPage } from "./pages/ClinkDirectPage/ClinkDirectPage";
import { FilialiC5Page } from "./pages/p3/FilialiPage/FilialiPage";
import { CodiceFiscalePage } from "./pages/CodiceFiscalePage/CodiceFiscalePage";
import { CodiceFiscaleC5Page } from "./pages/p3/CodiceFiscaleC5Page/CodiceFiscaleC5Page";
import { DatiPersonaliRiconosciutoPage } from "./pages/DatiPersonaliRiconosciutoPage/DatiPersonaliRiconosciutoPage";
import { DatiPersonaliRiconosciutoC5Page } from "./pages/p3/DatiPersonaliRiconosciutoPage/DatiPersonaliRiconosciutoPage";
import { DatiPersonaliNonRiconosciutoPage } from "./pages/DatiPersonaliNonRiconosciutoPage/DatiPersonaliNonRiconosciutoPage";
import { DatiPersonaliNonRiconosciutoC5Page } from "./pages/p3/DatiPersonaliNonRiconosciutoPage/DatiPersonaliNonRiconosciutoPage";
import { DatiPersonaliNonRiconosciutoBusinessPage } from "./pages/p5/DatiPersonaliNonRiconosciutoBusinessPage/DatiPersonaliNonRiconosciutoBusinessPage";
import { ClinkPage } from "./pages/ClinkPage/ClinkPage";
import { RiepilogoPage } from "./pages/RiepilogoPage/RiepilogoPage";
import { RiepilogoBusinessPage } from "./pages/p5/RiepilogoBusinessPage/RiepilogoBusinessPage";
import { RiepilogoC5Page } from "./pages/p3/RiepilogoPage/RiepilogoPage";
import { useEffect, useState } from "react";
import { useSession } from "./hooks/useSession";
import { useStates } from "./hooks/useStates";
import { t, randString } from "./services/formatters";
import { ClinkRicontattoPage } from "./pages/ClinkRicontattoPage/ClinkRicontattoPage";
import { EditAppointmentPage } from "./pages/EditAppointmentPage/EditAppointmentPage";

const ProtectedRoute = ({ children, canNavigateIf }) => {
    const { isCompassQuintoSite } = useSession();
    return canNavigateIf() ? children : <Navigate replace={true} to={isCompassQuintoSite() ? urls.codiceFiscaleC5.path : urls.luogo.path} />;
};

const App = () => {
    const { read, update } = useSession();
    const { isFilialiDirectPageReady, isFilialiPageReady, isCfPageReady, isDatiUtenteReady, isClinkYes, isRiepilogoPageReady, isClinkDirectPageReady } = useStates();
    const location = useLocation();

    const cUrl = window.location.pathname;
    const params = window.location.search;

    // 1. handle footer variables
    // prettier-ignore
    const [tassiFooter, setTassiFooter] = useState({USR_FA_PP_COMUNICAZIONI_TRASPARENZA_ANNUALI: "", USR_FA_PP_COMUNICAZIONI_TRASPARENZA_PERIODICHE: "",USR_FA_PP_DURATA_TOTALE_FINANZIAMENTO: "",USR_FA_PP_GESTIONE_PRATICA: "",USR_FA_PP_IMPORTO_TOTALE_CREDITO: "",USR_FA_PP_IMPORTO_TOTALE_DOVUTO: "",USR_FA_PP_ISTRUTTORIA: "",USR_FA_PP_MASSIMO_RICHIEDIBILE: "",USR_FA_PP_MINIMO_RICHIEDIBILE: "",USR_FA_PP_ONERI_FISCALI: "",USR_FA_PP_RIMBORSABILE_MASSIMO: "",USR_FA_PP_RIMBORSABILE_MINIMO: "",USR_FA_PP_TAEG: "",USR_FA_PP_TAEG_MASSIMO: "",USR_FA_PP_TAEG_MASSIMO_FIL: "",USR_FA_PP_TAEG_MINIMO_FIL: "",USR_FA_PP_TAN: "",USR_FA_PP_TAN_MASSIMO: "",USR_FA_PP_TAN_MASSIMO_FIL: "",USR_FA_PP_TAN_MINIMO_FIL: "",USR_GEN_VALIDITA: ""});
    let tassiTimeout = null;
    useEffect(() => {
        window.res3 = randString(20);

        tassiTimeout = setInterval(() => {
            if (window && undefined != window.USR_GEN_VALIDITA) {
                clearInterval(tassiTimeout);
                tassiTimeout = null;
                setTassiFooter({ ...window });
            }
        }, 100);

        if (
            cUrl == "/fa3/prestito-business" ||
            cUrl == "/fa3/prestito-business/" ||
            cUrl == "/fa-uat/prestito-business" ||
            cUrl == "/fa-uat/prestito-business/" ||
            cUrl == "/fa3/prestito-business/codice-fiscale" ||
            cUrl == "/fa3/prestito-business/codice-fiscale/" ||
            cUrl == "/fa-uat/prestito-business/codice-fiscale" ||
            cUrl == "/fa-uat/prestito-business/codice-fiscale/"
        ) {
            update("prodotto", 5);
            update("redirect", `${urls.prestitoBusiness.path}${params}`);
        }

        if (
            cUrl == "/fa3/c5" ||
            cUrl == "/fa3/c5/" ||
            cUrl == "/fa-uat/c5" ||
            cUrl == "/fa-uat/c5/" ||
            cUrl == "/fa3/c5/fissa-appuntamento" ||
            cUrl == "/fa3/c5/fissa-appuntamento/" ||
            cUrl == "/fa-uat/c5/fissa-appuntamento" ||
            cUrl == "/fa-uat/c5/fissa-appuntamento/" ||
            cUrl == "/fa3/c5/fissa-appuntamento/codice-fiscale" ||
            cUrl == "/fa3/c5/fissa-appuntamento/codice-fiscale/" ||
            cUrl == "/fa-uat/c5/fissa-appuntamento/codice-fiscale" ||
            cUrl == "/fa-uat/c5/fissa-appuntamentocodice-fiscale/" ||
            (window.location.host.indexOf("compassquinto") != -1 && window.location.search.indexOf("id_filiale_direct_c5") == -1)
        ) {
            update("prodotto", 3);
            update("redirect", `${urls.codiceFiscaleC5.path}${params}`);
        }
    }, []);

    // 2. stepbar and scroll to top for every page change
    useEffect(() => {
        updateStepBar();

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [location.pathname]);

    const getPageNameForPixel = () => {
        if (!location.pathname) return "-";

        let cleaned = location.pathname
            // .replace(/[^a-zA-Z0-9]+/g, "-")
            // .replace(/^-+|-+$/g, "")
            .toLowerCase();

        // check for previous steps to prepend
        let pixelSteps = [];
        if (read("pixelSteps")) {
            pixelSteps = [...read("pixelSteps")];
            pixelSteps.push(""); // let's make sure the + sign appears at the very end
        }

        // console.log(`${pixelSteps.join("+")}${cleaned}` || "home");
        return `${pixelSteps.join("+")}${cleaned == "/" || cleaned == "" ? "/home" : cleaned}`;
    };

    const updateStepBar = () => {
        try {
            update(
                "progress",
                urls[
                    Object.keys(urls).filter((_) => {
                        return urls[_].path == location.pathname;
                    })[0]
                ].progress
            );
        } catch (error) {
            update("progress", 0);
        }
    };

    useEffect(() => {
        window.dataLayer.push({
            funnelVersion: "nuovo",
        });
    }, []);
    let footer = (
        <>
            <h6 className="text-uppercase" aria-label={t("informazioni_generali")}>
                {t("informazioni_generali")}
            </h6>

            <div className="text-xs" aria-label={t("info_compass")}>
                Compass Banca S.p.A. - Sede Legale e Direzione Generale: Via Caldera, 21 - 20153 Milano, socio unico direzione e coordinamento Mediobanca S.p.A., Partita IVA Gruppo IVA Mediobanca:
                10536040966; C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati -{" "}
                <a href="https://www.compass.it/dati-societari-compass-spa.html" target="_blank">
                    Dati Societari
                </a>
                - Offerta promozionale valida fino al {tassiFooter.USR_GEN_VALIDITA}. Esempio rappresentativo: Importo totale del credito € {tassiFooter.USR_FA_PP_IMPORTO_TOTALE_CREDITO}. Importo
                totale dovuto € {tassiFooter.USR_FA_PP_IMPORTO_TOTALE_DOVUTO}. Modalità di rimborso con addebito diretto in conto (SDD). TAEG {tassiFooter.USR_FA_PP_TAEG}% inclusivo di: interessi al
                TAN Fisso {tassiFooter.USR_FA_PP_TAN}%; spese di istruttoria pari a € {tassiFooter.USR_FA_PP_ISTRUTTORIA}; spese incasso e gestione pratica € {tassiFooter.USR_FA_PP_GESTIONE_PRATICA} a
                rata; oneri fiscali applicati al contratto richiesti con prima rata €{tassiFooter.USR_FA_PP_ONERI_FISCALI}; oneri fiscali applicati alle comunicazioni periodiche di trasparenza €{" "}
                {tassiFooter.USR_FA_PP_COMUNICAZIONI_TRASPARENZA_PERIODICHE}; spese di invio comunicazione periodica di trasparenza annuale € {tassiFooter.USR_FA_PP_COMUNICAZIONI_TRASPARENZA_ANNUALI}{" "}
                se cartacea (gratuita online). Durata totale del finanziamento: {tassiFooter.USR_FA_PP_DURATA_TOTALE_FINANZIAMENTO} mesi. Documenti informativi disponibili sul sito{" "}
                <a href="https://www.compass.it/" target="_blank">
                    www.compass.it
                </a>{" "}
                nella sezione trasparenza, presso le Filiali Compass o presso gli Agenti in attività finanziaria di Compass Banca (Agenzie Autorizzate Compass) che operano in qualità di intermediari
                del credito monomandatari di Compass Banca S.p.A.. L'elenco delle Filiali e delle Agenzie Autorizzate Compass è disponibile sul sito{" "}
                <a href="https://www.compass.it/" target="_blank">
                    www.compass.it
                </a>
                . La liquidazione del prestito avviene entro il termine della giornata lavorativa successiva rispetto al momento in cui è stata fornita in Filiale o in Agenzia AUtorizzata la
                documentazione completa. Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A.. Importo richiedibile min. {tassiFooter.USR_FA_PP_MINIMO_RICHIEDIBILE}€
                max {tassiFooter.USR_FA_PP_MASSIMO_RICHIEDIBILE}€ rimborsabile min {tassiFooter.USR_FA_PP_RIMBORSABILE_MINIMO} mesi, max {tassiFooter.USR_FA_PP_RIMBORSABILE_MASSIMO} mesi. % tassi
                massimi applicati TAN {tassiFooter.USR_FA_PP_TAN_MASSIMO}% TAEG {tassiFooter.USR_FA_PP_TAEG_MASSIMO}%.
                <br />
                {t("footer_captcha")}
                <br />
                Condizioni suscettibili di variazione in caso di richiesta presentata in filiale TAN min {tassiFooter.USR_FA_PP_TAN_MINIMO_FIL}% TAN max {tassiFooter.USR_FA_PP_TAN_MASSIMO_FIL}% TAEG
                min {tassiFooter.USR_FA_PP_TAEG_MINIMO_FIL}% TAEG max {tassiFooter.USR_FA_PP_TAEG_MASSIMO_FIL}%.
            </div>
        </>
    );
    if (read("prodotto") == 5) {
        //Prestito business
        footer = (
            <>
                <h6 className="text-uppercase" aria-label={t("informazioni_generali")}>
                    {t("informazioni_generali")}
                </h6>

                <div className="text-xs" aria-label={t("info_compass")}>
                    Compass Banca S.p.A. - Sede Legale e Direzione Generale: Via Caldera, 21 - 20153 Milano, socio unico direzione e coordinamento Mediobanca S.p.A., Partita IVA Gruppo IVA Mediobanca:
                    10536040966; C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati -{" "}
                    <a href="https://www.compass.it/dati-societari-compass-spa.html" target="_blank">
                        Dati Societari
                    </a>{" "}
                    - Offerta promozionale valida fino al {tassiFooter.USR_GEN_VALIDITA}. Esempio rappresentativo: Importo totale del credito € {tassiFooter.USR_FA_BS_IMPORTO_TOTALE_CREDITO}. Importo
                    totale dovuto € {tassiFooter.USR_FA_BS_IMPORTO_TOTALE_DOVUTO}. Modalità di rimborso con addebito diretto in conto (SDD). TAEG {tassiFooter.USR_FA_BS_TAEG}% inclusivo di: interessi
                    al TAN Fisso {tassiFooter.USR_FA_BS_TAN}%; spese di istruttoria pari a € {tassiFooter.USR_FA_BS_ISTRUTTORIA}; spese incasso e gestione pratica €{" "}
                    {tassiFooter.USR_FA_BS_GESTIONE_PRATICA} a rata; oneri fiscali applicati al contratto richiesti con 1° rata € {tassiFooter.USR_FA_BS_ONERI_FISCALI}; oneri fiscali applicati alle
                    comunicazioni periodiche di trasparenza € {tassiFooter.USR_FA_BS_COMUNICAZIONI_TRASPARENZA_PERIODICHE}; spese di invio comunicazione periodica di trasparenza annuale €{" "}
                    {tassiFooter.USR_FA_BS_COMUNICAZIONI_TRASPARENZA_ANNUALI} se cartacea (gratuita online). Durata totale del finanziamento: {tassiFooter.USR_FA_BS_DURATA_TOTALE_FINANZIAMENTO} mesi.
                    Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A.. Documenti informativi disponibili sul sito{" "}
                    <a href="https://www.compass.it" target="_blank">
                        www.compass.it
                    </a>{" "}
                    nella sezione trasparenza, presso le Filiali Compass o presso gli Agenti in attività finanziaria di Compass Banca (Agenzie Autorizzate Compass) che operano in qualità di
                    intermediari del credito monomandatari di Compass Banca S.p.A.. L'elenco delle Filiali e delle Agenzie Autorizzate Compass è disponibile sul sito{" "}
                    <a href="https://www.compass.it" target="_blank">
                        www.compass.it
                    </a>
                    . Importo richiedibile min. {tassiFooter.USR_FA_BS_MINIMO_RICHIEDIBILE}€ max {tassiFooter.USR_FA_BS_MASSIMO_RICHIEDIBILE}€ rimborsabile min{" "}
                    {tassiFooter.USR_FA_BS_RIMBORSABILE_MINIMO} mesi, max {tassiFooter.USR_FA_BS_RIMBORSABILE_MASSIMO} mesi. % tassi massimi applicati TAN {tassiFooter.USR_FA_BS_TAN_MASSIMO}% TAEG{" "}
                    {tassiFooter.USR_FA_BS_TAEG_MASSIMO}%.
                    <br />
                    Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;<a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e i{" "}
                    <a href="https://policies.google.com/terms">Termini di servizio</a> di Google.
                </div>
            </>
        );
    } else if (read("prodotto") == 3) {
        //Cessione del quinto
        footer = (
            <>
                <h6 className="text-uppercase" aria-label={t("informazioni_generali")}>
                    {t("informazioni_generali")}
                </h6>

                <div className="text-xs" aria-label={t("info_compass")}>
                    <p>
                        Messaggio pubblicitario con finalità promozionale. Per le condizioni economiche e contrattuali si rimanda ai documenti informativi disponibili sul sito&nbsp;
                        <a href="https://www.compass.it" target="_blank">
                            www.compass.it
                        </a>
                        &nbsp;e&nbsp;
                        <a href="https://www.compassquinto.it" target="_blank">
                            www.compassquinto.it
                        </a>{" "}
                        nella sezione Trasparenza, presso le Filiali Compass o presso gli agenti in attività finanziaria di Compass Banca (Agenzie Autorizzate Compass Quinto) che operano in qualità di
                        intermediari del credito con mandato in esclusiva di prodotto di Compass Banca S.p.A.. L'elenco delle Filiali Compass e delle Agenzie Autorizzate Compass Quinto è disponibile
                        sul sito{" "}
                        <a href="https://www.compass.it" target="_blank">
                            www.compass.it
                        </a>{" "}
                        e{" "}
                        <a href="https://www.compassquinto.it" target="_blank">
                            www.compassquinto.it
                        </a>
                        . Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A.. Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del
                        quinto dello stipendio richiesto da un dipendente pubblico di {tassiFooter.USR_FA_C5_ETA_DIPENDENTE_PUBBLICO} anni. Importo totale del credito{" "}
                        {tassiFooter.USR_FA_C5_IMPORTO_TOTALE_CREDITO} €. Importo totale dovuto {tassiFooter.USR_FA_C5_IMPORTO_TOTALE_DOVUTO} €. Durata del contratto:{" "}
                        {tassiFooter.USR_FA_C5_DURATA_CONTRATTO} mesi. Importo rata {tassiFooter.USR_FA_C5_IMPORTO_RATA} €. TAEG {tassiFooter.USR_FA_C5_TAEG}% inclusivo di: interessi al Tan Fisso{" "}
                        {tassiFooter.USR_FA_C5_TAN} % e bollo {tassiFooter.USR_FA_C5_BOLLO} €. Offerta valida fino al {tassiFooter.USR_GEN_VALIDITA}. Ogni finanziamento prevede delle coperture
                        assicurative, di cui Compass Banca S.p.A. sarà contraente e beneficiaria, dovute per legge ai sensi del DPR n. 180/50. Prestito rimborsabile in minimo{" "}
                        {tassiFooter.USR_FA_C5_RIMBORSABILE_MINIMO} rate e massimo {tassiFooter.USR_FA_C5_RIMBORSABILE_MASSIMO} rate. TAEG massimo applicabile per il trimestre di riferimento, fino al{" "}
                        {tassiFooter.USR_GEN_VALIDITA}:{tassiFooter.USR_FA_C5_TAEG_MASSIMO}%. Compass Quinto è un marchio di Compass Banca S.p.A., socio unico direzione e coordinamento Mediobanca
                        S.p.A., - N. Partita IVA Gruppo IVA Mediobanca: 10536040966., C.F e n. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati. : 20153 Milano - Via Caldera, 21.{" "}
                        <a href="https://www.compass.it/dati-societari-compass-spa.html" target="_blank">
                            Dati societari
                        </a>
                        <br />
                        <br />
                        Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;
                        <a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e i&nbsp;
                        <a href="https://policies.google.com/terms">Termini di servizio</a>&nbsp;di Google.
                    </p>
                </div>
            </>
        );
    }

    const logoUrl = read("prodotto") == 3 ? logoC5 : logo;
    return (
        <>
            <div id="layout-container">
                <header id="layout-header">
                    <img
                        onClick={() => {
                            window.open(read("prodotto") == 3 ? "https://www.compassquinto.it/" : "https://www.compass.it/", "_blank");
                        }}
                        className={"logo clickable " + (read("prodotto") == 3 ? "c5Logo" : "standardLogo")}
                        src={logoUrl}
                        alt="Compass"
                    />
                    <>
                        <div className="step-bar step-bar-component" style={{ width: `${read("progress")}%` }}></div>
                        <div className="step-bar-background" style={{ width: `${100 - read("progress")}%` }}></div>
                    </>
                </header>

                <main className="section" id="layout-content">
                    <Routes>
                        {/* <Route path={urls.home.path} element={<LoadingPage />} /> */}
                        <Route
                            path={urls.luogo.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return true;
                                    }}>
                                    <LuogoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.luogoC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        const ready = read("prodotto") == 3 && read("codiceFiscale") != "";
                                        return ready;
                                    }}>
                                    <LuogoC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.filiali.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isFilialiPageReady();
                                    }}>
                                    <FilialiPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.filialiDirect.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isFilialiDirectPageReady();
                                    }}>
                                    <FilialiDirectPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.filialiDirectC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isFilialiDirectPageReady();
                                    }}>
                                    <FilialiDirectC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.clinkDirect.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isClinkDirectPageReady();
                                    }}>
                                    <ClinkDirectPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.filialiC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isFilialiPageReady();
                                    }}>
                                    <FilialiC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.codiceFiscale.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isCfPageReady();
                                    }}>
                                    <CodiceFiscalePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.codiceFiscaleC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        const ready = read("prodotto") == 3;
                                        return ready;
                                    }}>
                                    <CodiceFiscaleC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.prestitoBusiness.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        const ready = read("prodotto") == 5;
                                        return ready;
                                    }}>
                                    <PrestitoBusinessPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliRiconosciuto.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isDatiUtenteReady();
                                    }}>
                                    <DatiPersonaliRiconosciutoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliRiconosciutoC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        const isReady = read("prodotto") == 3;
                                        return isReady;
                                    }}>
                                    <DatiPersonaliRiconosciutoC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliNonRiconosciutoBusiness.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isDatiUtenteReady();
                                    }}>
                                    <DatiPersonaliNonRiconosciutoBusinessPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliNonRiconosciutoC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        const ready = read("prodotto") == 3;
                                        return ready;
                                    }}>
                                    <DatiPersonaliNonRiconosciutoC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliNonRiconosciuto.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isDatiUtenteReady();
                                    }}>
                                    <DatiPersonaliNonRiconosciutoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.clink.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isDatiUtenteReady();
                                    }}>
                                    <ClinkPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.clinkRicontatto.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isClinkYes();
                                    }}>
                                    <ClinkRicontattoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.riepilogo.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isRiepilogoPageReady();
                                    }}>
                                    <RiepilogoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.riepilogoBusiness.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isRiepilogoPageReady();
                                    }}>
                                    <RiepilogoBusinessPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.riepilogoC5.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return read("prodotto") == 3;
                                    }}>
                                    <RiepilogoC5Page />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.modificaAppuntamento.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return true;
                                    }}>
                                    <EditAppointmentPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Not found - back to Home page */}
                        <Route
                            path="*"
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return false;
                                    }}></ProtectedRoute>
                            }
                        />
                    </Routes>
                </main>

                <footer className="section" id="layout-footer">
                    {footer}
                    <img src={`https://c0mp.as/track${getPageNameForPixel()}.png`} alt="" />
                </footer>
            </div>
        </>
    );
};

export default App;
